import React,{useState} from "react";
export default function ToDoList(){
const[item,setItem]=useState('')
const[print,setPrint]=useState([]);
const[edit,setEdit]=useState(null);


function addText(event){
 if(!item){

} 
else {    
      if (edit !== null) {
        print[edit] = item;
        setEdit(null);
        setItem('');
}
 
 else{
        setPrint([...print,item])
    setItem('');
 }
}}
function deleteItem(id){
const updatedItem= print.filter((currValue,index)=>{
    return index!==id;
})
setPrint(updatedItem);
}
//remove all 
function removeAll(){
    setPrint([])
}

//edit 
const editBtn=(index)=>{
    const editTodo=print[index];
    setItem(editTodo);
    setEdit(index)  

         
}
return(
    <>
    <div className="main">
       <div className="container">
           <div className="center">
                   <div className="heading">
                   <h2>ToDo List App</h2>
                   </div>
                   <div className="box">
                   <input type="text" className="textArea" placeholder="type here..." value={item} onChange={(e)=>{setItem(e.target.value)}}/>
                   <button className="todoBtn" onClick={addText}> {edit?"Edit":"AddText"} </button>
                   
                   </div>
                   <div className="output"> 
                   <div className="op_center">


     {
   print.map((currentElem,index)=>{
    return( <ul key={index}>
        <li className="list">{currentElem}<button onClick={()=>editBtn(index)} >Edit</button> <button onClick={()=>deleteItem(index)}>X</button ></li>
    </ul> )
    
   })
}


{/* <button onClick={removeAll}>remove All</button> */}
                    </div>              
</div>

 </div>
       </div>
    </div>


    
    <div className="outerLayer">
   






    
    </div>
    
           {/* for remove all data */}
    <div>
        {/* <button onClick={removeAll}>remove All</button> */}
    </div>
    </>
)
}